import { Card, makeStyles, Skeleton, SkeletonItem, tokens } from '@fluentui/react-components';

export default function FormSkeleton() {
	const classes = useStyles();
	return (
		<div className={classes.root}>
			<Card className={classes.boxRoot}>
				<Skeleton>
					<SkeletonItem className={classes.boxSkeleton} />
				</Skeleton>
			</Card>
			<div className={classes.divider} />
			<Card className={classes.boxRoot}>
				<Skeleton>
					<SkeletonItem className={classes.boxSkeleton} />
				</Skeleton>
			</Card>
			<>
				<div className={classes.divider} />
				<div className={classes.buttonSkeletonRoot}>
					<Skeleton className={classes.buttonSkeleton}>
						<SkeletonItem style={{ height: '100%' }} />
					</Skeleton>
				</div>
				<div className={classes.divider} />
			</>
			<Card className={classes.boxRoot}>
				<Skeleton>
					<SkeletonItem className={classes.boxSkeleton} />
				</Skeleton>
			</Card>
			<>
				<div className={classes.divider} />
				<div className={classes.buttonSkeletonRoot}>
					<Skeleton className={classes.buttonSkeleton}>
						<SkeletonItem style={{ height: '100%' }} />
					</Skeleton>
				</div>
			</>
		</div>
	);
}

const useStyles = makeStyles({
	root: {},
	boxRoot: {
		width: '100%',
		padding: '0'
	},
	boxSkeleton: {
		height: '92px',
	},
	divider: {
		height: '32px',
		width: '1px',
		backgroundColor: tokens.colorNeutralForegroundDisabled,
		marginLeft: '32px'
	},
	buttonSkeletonRoot: {
		height: '24px',
		width: '92px',
		border: `solid 1px ${tokens.colorNeutralForegroundDisabled}`,
		borderRadius: '4px'
	},
	buttonSkeleton: {
		width: '100%',
		height: '100%'
	}
});